<template>
  <!--
        作者：luoyiming
        时间：2020-06-20
        描述：diy组件-参数设置-单图组
      -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--上下边距-->
      <el-form-item label="上下边距：">
        <el-slider v-model="curItem.style.paddingTop" style="width: 50%" show-input></el-slider>
      </el-form-item>
      <!--左右边距-->
      <el-form-item label="左右边距：">
        <el-slider v-model="curItem.style.paddingLeft" style="width: 50%" :min="0" :max="50" show-input></el-slider>
      </el-form-item>
      <!--背景颜色-->
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;"
                     @click.stop="$parent.onEditorResetColor(curItem.style, 'background', '#ffffff')">重置
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="图片：">
        <div class="param-img-item  d-s-c" :key="index" v-for="(imageSingle, index) in curItem.data">
          <div class="delete-box"><i class="el-icon-delete-solid"
                                     @click="$parent.onEditorDeleleData(index, selectedIndex)"></i></div>
          <div class="pic d-c-c"><img v-img-url="imageSingle.imgUrl" alt="" style="object-fit: contain;"
                                      @click="$parent.onEditorSelectImage(imageSingle, 'imgUrl')"></img></div>
          <div class="d-c-s d-c ml20" style="width: 70%">
            <div class="url-box">
              <span class="key-name">链接地址：</span>

            </div>
            <div class="url-box flex-1 d-s-c">
              <el-input v-model="imageSingle.name"></el-input>
              <el-button style="margin-left:20px;height: 32px" type="primary" @click="changeLink(index)">选择链接
              </el-button>
            </div>
          </div>
        </div>
        <div class="d-c-c">
          <el-button @click="$parent.onEditorAddData">添加一个</el-button>
        </div>
      </el-form-item>
    </el-form>
    <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</Setlink>
  </div>
</template>

<script>
import Setlink from '@/components/setlink/Setlink'

export default {
  components: {

    Setlink,
  },
  data () {
    return {
      /*是否选择链接*/
      is_linkset: false,
      index: null,
    }
  },
  created () {
    this.curItem.style.paddingTop = parseInt(this.curItem.style.paddingTop)
    this.curItem.style.paddingLeft = parseInt(this.curItem.style.paddingLeft)
  },
  props: ['curItem', 'selectedIndex'],
  methods: {
    /*选择链接*/
    changeLink (index) {
      this.is_linkset = true
      this.index = index
    },
    /*获取链接并关闭弹窗*/
    closeLinkset (e) {
      this.is_linkset = false
      this.curItem.data[this.index].linkUrl = e.url
//                this.curItem.data[this.index].name = e.name;
      this.curItem.data[this.index].name = '链接到' + ' ' + e.type + ' ' + e.name
    },
  }
}
</script>

<style>
/*.pic{*/
/*  width: 200px;*/
/*  height: 100px;*/

/*}*/
/*.pic img{*/
/*  width: 100% !important;*/
/*  height: auto !important;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/ImageSingle.vue